export const dateDifferenceInMinutes = (startDate: Date, endDate: Date): number => {
  const diffInMilliseconds: number = Math.abs(endDate.getTime() - startDate.getTime());
  const diffInMinutes: number = Math.floor(diffInMilliseconds / (1000 * 60));

  return diffInMinutes;
};
